import {
  AuthPopupFixed,
  PopupTopper,
  SignUpContainerForm,
  SignUpWrapperSC,
} from '@setplex/arcane'
import { useUnit } from 'effector-react'
import { SignInForm } from './components/SignInForm'
import { $isOpenedSignInPopup, checkEnableToClose } from './model'

SignInPopup.displayName = 'SignInPopup'
export function SignInPopup() {
  const isOpenedSignInPopup = useUnit($isOpenedSignInPopup)
  const onClose = () => checkEnableToClose()

  return (
    <AuthPopupFixed
      wrapperId='sign-in'
      className='auth-popup-container-sign-in'
      isOpened={isOpenedSignInPopup}
      onClickForClosingPopup={onClose}
    >
      <SignUpWrapperSC>
        <SignUpContainerForm>
          <PopupTopper onClose={onClose} />
          <SignInForm />
        </SignUpContainerForm>
      </SignUpWrapperSC>
    </AuthPopupFixed>
  )
}
